{
    "DocumentViewer_AcceptButton": "Accepteren",
    "DocumentViewer_CloseButton": "Afsluiten",
    "NAME": "DocumentViewer"
}